<template>
  <div class="container-fluid">
    <div class="row">
      <div class="col">
        <card>
          <div class="card__title">
            <h4>{{ $t('Send us a message') }}</h4>
          </div>
          <div class="card__body">
            <el-form class="contactForm" :model="message" @submit.native.prevent="sendMail">
              <el-form-item :label="$t('Theme')">
                <el-input
                  type="text"
                  v-model="message.subject"
                  data-vv-name="subject"
                  v-validate="'required'"></el-input>
              </el-form-item>
              <el-form-item :label="$t('Message')">
                <el-input
                  type="textarea"
                  :rows="10"
                  v-model="message.body"
                  data-vv-name="body"
                  v-validate="'required'">
                </el-input>
              </el-form-item>
              <el-button
                type="primary"
                nativeType="submit"
                :loading="sending"
                :disabled="!message.subject || !message.body"
              >
                {{ $t('Send') }}
              </el-button>
            </el-form>
          </div>
        </card>
      </div>
      <div class="col-md-4">
        <card>
          <div class="card__title">
            <h4>{{ $t('Contacts') }}</h4>
          </div>
          <div class="card__body">
            <ul slot="raw-content" class="list-group list-group-flush contacts">
              <li class="list-group-item" v-if="contacts.phones">
                <div class="contact-header">
                  <i class="now-ui-icons tech_mobile"></i>
                  <h6>{{ $t('Phones') }}</h6>
                </div>
                <ul class="contacts-list">
                  <li v-for="(value, key) in contacts.phones" :key="key">
                    <span v-if="value">{{ value + ': '}}</span>
                    <a :href="`tel:${key}`" rel="noopener noreferrer">{{ key }}</a>
                  </li>
                </ul>
              </li>
              <li class="list-group-item" v-if="contacts.links">
                <div class="contact-header">
                  <i class="now-ui-icons objects_globe"></i>
                  <h6>{{$t('Links')}}</h6>
                </div>
                <ul class="contacts-list">
                  <li v-for="(value, key) in contacts.links" :key="key">
                    <span v-if="value">{{ value + ': '}}</span>
                    <a :href="key" target="_blank" rel="noopener noreferrer">{{ key }}</a>
                  </li>
                </ul>
              </li>
              <li class="list-group-item" v-if="contacts.addresses">
                <div class="contact-header">
                  <i class="now-ui-icons location_pin"></i>
                  <h6>{{$t('Addresses')}}</h6>
                </div>
                <ul class="contacts-list">
                  <li v-for="(value, key) in contacts.addresses" :key="key">
                    <span v-if="value">{{ value + ': '}}</span> {{ key }}
                  </li>
                </ul>
              </li>
            </ul>
          </div>
        </card>
      </div>
    </div>
  </div>
</template>

<script>
import { Form, FormItem, Input, Button } from 'element-ui'
import { mapState } from 'vuex'
import axios from 'axios'

export default {
  name: 'Contacts',
  components: {
    'el-button': Button,
    'el-form': Form,
    'el-form-item': FormItem,
    'el-input': Input
  },
  data() {
    return {
      message: {
        subject: '',
        body: ''
      },
      sending: false
    }
  },
  computed: {
    ...mapState({
      title: state => state.config.data.title,
      contacts: state => state.config.data.contacts
    })
  },
  methods: {
    sendMail() {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.sending = true
          axios.post('email/create', { ...this.message })
            .then(promise => {
              this.sending = false
              this.resetForm()
              this.$notify(
                {
                  message: this.$t('Message sent'),
                  horizontalAlign: 'center',
                  verticalAlign: 'top',
                  type: 'success',
                  timeout: 1500
                })
            })
            .catch(error => {
              this.sending = false
              console.log('error', error.response.data)
              this.$notify(
                {
                  message: 'An error occurred while sending your message. Please try later.',
                  horizontalAlign: 'center',
                  verticalAlign: 'top',
                  type: 'danger',
                  timeout: 1500
                })
            })
        }
      })
    },
    resetForm() {
      Object.assign(this.$data.message, this.$options.data().message)
    }
  }
}
</script>

<style lang="scss" scoped>
  .contacts {
    margin-bottom: 25px;
    i {
      font-size: 24px;
    }
    > .list-group-item {
      padding-left: 0;
    }
  }
  .contact-header {
    display: flex;
    align-items: center;
    margin-bottom: 10px;
    color: #9A9A9A;

    h6 {
      margin-left: 8px;
      margin-bottom: 0;
      font-weight: 400;
    }
  }
  .contacts-list {
    list-style: none;
    margin-left: 32px;
    padding: 0;
  }
  span {
    font-weight: 700;
  }
</style>
